import React, { useEffect, useState } from 'react'
import { Container } from './styles'
import oldSkills from '../../services/skills'

interface ISkill {
  id: string
  title: string
  subtitle: string
  image: string
  category: string
  description: string
}

export default function Skills() {
  const [skillsAll, setSkillAll] = useState<ISkill[]>([])

  useEffect(() => {
    setSkillAll(oldSkills)
  }, [])

  return (
    <Container>
      <>
        {skillsAll.map((skill) => (
          <div key={skill.id}>
            <h4>{skill.title}</h4>
            <img src={skill.image} alt='imagem da skill' />
          </div>
        ))}
        <section></section>
      </>
    </Container>
  )
}
